import type { ReactNode } from "react";
import type { PreneedDashboardPayload } from "../../../api/preneed-section/preneed-dashboard.api";

export type SharedDashboardTableColumnKey =
  | "date"
  | "orderId"
  | "orderAmount"
  | "afpCommission"
  | "myEarnings";

export interface SharedDashboardTableHeader {
  key: SharedDashboardTableColumnKey;
  label: string;
}

export interface SharedDashboardProps {
  mode?: DashboardMode;
}

export interface ProjectedRow {
  date: string;
  orderId: string;
  orderAmount: string;
  afpCommission: string;
  myEarnings: string;
}

export interface BookingSummaryItem {
  label: "Completed" | "New" | "Active" | "Cancelled";
  value: number;
  tone: "success" | "info" | "warning" | "danger";
  icon: ReactNode;
}

export interface ServiceChartItem {
  label: string;
  completed: number;
  cancelled: number;
}

export interface DashboardPayloadLike extends Partial<PreneedDashboardPayload> {
  myServices?: ProviderServiceSummary[];
  myBookingsTotal?: number;
  myServicesTotal?: number;
  myPackagesTotal?: number;
  myEarningsTotal?: number;
}

export interface ProviderServiceSummary {
  serviceName?: string;
  packageName?: string;
  categoryName?: string;
  completed?: number;
  pending?: number;
  paid?: number;
  cancelled?: number;
}

export interface SessionTokenShape {
  accessToken?: string;
  token?: string;
  data?: {
    accessToken?: string;
    token?: string;
  };
}

export type DashboardMode = "provider" | "preNeed";

export const PROJECTED_EARNINGS_HEADERS: SharedDashboardTableHeader[] = [
  { key: "date", label: "DATE" },
  { key: "orderId", label: "ORDER ID" },
  { key: "orderAmount", label: "ORDER AMOUNT" },
  { key: "afpCommission", label: "AFP COMMISSION" },
  { key: "myEarnings", label: "MY EARNINGS" },
];
